import createIcon from '../../createIcon';

/**
 * @component @name OpenInFull
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgMTFWM0gxM0wxNi4yOSA2LjI5TDYuMjkgMTYuMjlMMyAxM1YyMUgxMUw3LjcxIDE3LjcxTDE3LjcxIDcuNzFMMjEgMTFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const OpenInFull = createIcon('OpenInFull', [
  [
    'path',
    {
      d: 'M21 11V3H13L16.29 6.29L6.29 16.29L3 13V21H11L7.71 17.71L17.71 7.71L21 11Z',
      key: 'ejw7lc',
    },
  ],
]);

export default OpenInFull;
